import { render, staticRenderFns } from "./ButtonsFilters.vue?vue&type=template&id=4d62d264&scoped=true&lang=pug"
import script from "./ButtonsFilters.vue?vue&type=script&lang=js"
export * from "./ButtonsFilters.vue?vue&type=script&lang=js"
import style0 from "./ButtonsFilters.vue?vue&type=style&index=0&id=4d62d264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d62d264",
  null
  
)

export default component.exports